import React from 'react';
import { BillingDetailsSection } from './billing-details-section';

const BillingDetailsTabContent = () => {
  return <BillingDetailsSection />;
};

export { BillingDetailsTabContent };
